import { render, staticRenderFns } from "./CrmUserWelcome.vue?vue&type=template&id=3db05ae8&scoped=true&"
import script from "./CrmUserWelcome.vue?vue&type=script&lang=js&"
export * from "./CrmUserWelcome.vue?vue&type=script&lang=js&"
import style0 from "./CrmUserWelcome.vue?vue&type=style&index=0&id=3db05ae8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db05ae8",
  null
  
)

export default component.exports